import React, { useState } from 'react';
import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { Button, Input, Row, Col } from 'antd';
import CustomButton from 'styles/buttonStyled';
import { useTranslation } from 'react-i18next';

const CertificationsField = ({
  name,
  onChange,
  disabled,
}: {
  name: string;
  onChange: (data: any) => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation(['recruitment', 'action']);
  const [isFocused, setIsFocused] = useState(false);
  const { control, handleSubmit } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name,
  });

  const onSubmit = (data: any) => {
    onChange(data);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      {fields.map((item, index) => (
        <Row key={item.id} gutter={8} style={{ marginBottom: 8 }}>
          <Col span={disabled ? 12 : 10}>
            <Controller
              name={`${name}[${index}].name`}
              control={control}
              defaultValue={item.name}
              render={({ field }) => (
                <Input
                  placeholder={disabled ? undefined : 'Certification Name'}
                  {...field}
                  disabled={disabled}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => {
                    setIsFocused(false);
                    handleSubmit(onSubmit)();
                  }}
                  onChange={(e) => {
                    field.onChange(e);
                    if (!isFocused) {
                      handleSubmit(onSubmit)();
                    }
                  }}
                />
              )}
            />
          </Col>
          <Col span={disabled ? 12 : 10}>
            <Controller
              name={`${name}[${index}].link`}
              control={control}
              defaultValue={item.link}
              render={({ field }) => (
                <Input
                  placeholder={disabled ? undefined : 'Certification Link'}
                  {...field}
                  disabled={disabled}
                  onFocus={() => setIsFocused(true)}
                  onBlur={() => {
                    setIsFocused(false);
                    handleSubmit(onSubmit)();
                  }}
                  onChange={(e) => {
                    field.onChange(e);
                    if (!isFocused) {
                      handleSubmit(onSubmit)();
                    }
                  }}
                />
              )}
            />
          </Col>
          {!disabled && (
            <Col span={4}>
              <CustomButton
                style={{ width: 50 }}
                onClick={() => {
                  remove(index);
                  handleSubmit(onSubmit)();
                }}
              >
                x
              </CustomButton>
            </Col>
          )}
        </Row>
      ))}
      <Button
        type="dashed"
        disabled={disabled}
        onClick={() => {
          append({ name: '', link: '' });
          handleSubmit(onSubmit)();
        }}
      >
        {t('recruitment:add_certification')}
      </Button>
    </form>
  );
};

export default CertificationsField;
